import { Component } from '@angular/core';
import { BlockCarousel } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-carousel',
  templateUrl: './block-carousel.component.html',
})
export class BlockCarouselComponent extends BlockAbstractComponent<BlockCarousel, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
